import { useMatch } from '@reach/router';

export function useCurrentLocationId(): string | undefined {
  const { locationId } = useMatch('/:locationId/*') || {
    locationId: undefined,
  };
  return locationId;
}
